
export default `
  display: inline-block;
  position: relative;
  user-select: none;
`;
